export const objectives = [
  {
    icon: 'ri-megaphone-line',
    title: 'Policy Advocacy',
    desc: 'Represent member interests before state and central government bodies, shaping ethanol policy for Bihar\'s benefit.',
  },
  {
    icon: 'ri-shake-hands-line',
    title: 'OMC Procurement Support',
    desc: 'Facilitate bulk procurement agreements between member distilleries and Oil Marketing Companies (IOCL, BPCL, HPCL).',
  },
  {
    icon: 'ri-seedling-line',
    title: 'Farmer Linkage',
    desc: 'Strengthen supply chain connections between Bihar\'s sugarcane and grain farmers and ethanol manufacturers.',
  },
  {
    icon: 'ri-bar-chart-line',
    title: 'Capacity Building',
    desc: 'Support members in scaling production capacity to meet India\'s E20 blending targets by 2025.',
  },
  {
    icon: 'ri-file-text-line',
    title: 'Regulatory Compliance',
    desc: 'Guide members through licensing, environmental clearances, and quality standards for fuel-grade ethanol.',
  },
  {
    icon: 'ri-global-line',
    title: 'Industry Promotion',
    desc: 'Promote Bihar as a leading ethanol-producing state through national forums, events, and media outreach.',
  },
];

export const knowledgePolicies = [
  {
    id: 1,
    title: 'National Biofuel Policy 2018',
    category: 'Central Policy',
    date: 'June 2018',
    summary: 'Sets the national framework for ethanol blending targets — E5, E10, E20 — with annual pricing revisions by MoPNG.',
    icon: 'ri-government-line',
    accent: '#28a99e',
    tag: 'Active',
  },
  {
    id: 2,
    title: 'Ethanol Blended Petrol (EBP) Programme',
    category: 'Central Policy',
    date: 'Ongoing',
    summary: 'Mandates OMCs to procure domestically produced ethanol for blending with petrol. Bihar is a key supplier state.',
    icon: 'ri-gas-station-line',
    accent: '#28a99e',
    tag: 'Active',
  },
  {
    id: 3,
    title: 'Bihar Ethanol Incentive Package 2021',
    category: 'State Policy',
    date: 'March 2021',
    summary: 'State fiscal incentives including interest subvention, capital subsidy, and single-window clearance for new distilleries.',
    icon: 'ri-building-2-line',
    accent: '#008000',
    tag: 'Active',
  },
  {
    id: 4,
    title: 'E20 Roadmap — India 2025',
    category: 'Central Policy',
    date: 'February 2025',
    summary: 'Government of India\'s accelerated roadmap to achieve 20% ethanol blending in petrol by 2025, ahead of original 2030 target.',
    icon: 'ri-road-map-line',
    accent: '#F0C808',
    tag: 'Target',
  },
  {
    id: 5,
    title: 'PMKSY — Pradhan Mantri Krishi Sinchayee Yojana',
    category: 'Agriculture',
    date: 'Ongoing',
    summary: 'Irrigation support scheme strengthening feedstock farmer productivity, directly benefiting ethanol supply chains.',
    icon: 'ri-plant-line',
    accent: '#008000',
    tag: 'Active',
  },
  {
    id: 6,
    title: 'PLI Scheme for Food Processing',
    category: 'Central Policy',
    date: '2021',
    summary: 'Production Linked Incentive scheme by MoFPI providing financial assistance for grain-based distillery expansion.',
    icon: 'ri-money-rupee-circle-line',
    accent: '#28a99e',
    tag: 'Active',
  },
];

export const articles = [
  {
    id: 1,
    title: 'Bihar\'s Ethanol Revolution: From Sugarcane Fields to Fuel Stations',
    category: 'Whitepaper',
    date: 'March 2026',
    author: 'BEA Research Cell',
    summary: 'A comprehensive analysis of Bihar\'s ethanol production journey, covering feedstock availability, distillery capacity, and OMC procurement trends.',
    readTime: '12 min read',
    accent: '#28a99e',
  },
  {
    id: 2,
    title: 'E20 Blending: Opportunities and Challenges for Bihar Manufacturers',
    category: 'Article',
    date: 'January 2026',
    author: 'Rajiv Kumar Sinha, President BEA',
    summary: 'An in-depth look at what India\'s E20 mandate means for Bihar\'s distillery sector — investment requirements, capacity gaps, and policy support needed.',
    readTime: '8 min read',
    accent: '#008000',
  },
  {
    id: 3,
    title: 'Grain-Based Ethanol: Bihar\'s New Growth Engine',
    category: 'Article',
    date: 'November 2025',
    author: 'BEA Policy Team',
    summary: 'How the shift from sugarcane to grain-based ethanol production is transforming Bihar\'s distillery landscape and creating new rural employment.',
    readTime: '6 min read',
    accent: '#F0C808',
  },
  {
    id: 4,
    title: 'Farmer-Distillery Linkage Models in Bihar: Case Studies',
    category: 'Whitepaper',
    date: 'September 2025',
    author: 'BEA Research Cell',
    summary: 'Documenting successful farmer-distillery partnership models across West Champaran, Gopalganj, and Muzaffarpur districts.',
    readTime: '15 min read',
    accent: '#28a99e',
  },
];

export const yearlyReports = [
  { year: '2025-24', title: 'Annual Report 2025-24', pages: '48 pages', size: '4.2 MB', highlight: 'Record 3,100 KLPD capacity achieved' },
  { year: '2022-23', title: 'Annual Report 2022-23', pages: '42 pages', size: '3.8 MB', highlight: '12 new distilleries commissioned' },
  { year: '2021-22', title: 'Annual Report 2021-22', pages: '38 pages', size: '3.1 MB', highlight: 'E10 blending milestone reached' },
  { year: '2020-21', title: 'Annual Report 2020-21', pages: '35 pages', size: '2.9 MB', highlight: 'Grain-based expansion begins' },
];

export const events = [
  {
    id: 1,
    title: 'Bihar Ethanol Conclave 2026',
    date: 'November 15, 2026',
    location: 'Hotel Maurya, Patna',
    type: 'Conference',
    status: 'upcoming',
    description: 'Annual flagship event bringing together distillers, government officials, OMC representatives, and financial institutions to discuss Bihar\'s ethanol roadmap.',
    accent: '#28a99e',
  },
  {
    id: 2,
    title: 'E20 Readiness Workshop',
    date: 'September 8, 2026',
    location: 'BEA Office, Patna',
    type: 'Workshop',
    status: 'upcoming',
    description: 'Technical workshop for member distilleries on upgrading production processes to meet E20-grade ethanol quality standards.',
    accent: '#008000',
  },
  {
    id: 3,
    title: 'Farmer-Distillery Partnership Summit',
    date: 'July 20, 2026',
    location: 'Muzaffarpur Convention Centre',
    type: 'Summit',
    status: 'upcoming',
    description: 'Connecting Bihar\'s sugarcane and grain farmers directly with ethanol manufacturers to strengthen supply chain linkages.',
    accent: '#F0C808',
  },
  {
    id: 4,
    title: 'Bihar Ethanol Conclave 2025',
    date: 'November 18, 2025',
    location: 'Hotel Maurya, Patna',
    type: 'Conference',
    status: 'past',
    description: 'Over 200 delegates attended the 2025 conclave. Key outcomes included a joint resolution on E20 capacity expansion and a new MoU with IOCL.',
    accent: '#28a99e',
    highlights: ['200+ delegates', 'IOCL MoU signed', 'E20 resolution passed'],
  },
  {
    id: 5,
    title: 'National Biofuel Day Celebration',
    date: 'August 10, 2025',
    location: 'Patna',
    type: 'Event',
    status: 'past',
    description: 'BEA organized state-level celebrations for National Biofuel Day with participation from Dept. of Industries, Bihar.',
    accent: '#008000',
    highlights: ['State Govt. participation', 'Media coverage', '500+ attendees'],
  },
  {
    id: 6,
    title: 'Grain-Based Distillery Investor Meet',
    date: 'April 5, 2025',
    location: 'Patna',
    type: 'Investor Meet',
    status: 'past',
    description: 'Facilitated meetings between potential investors and Bihar\'s distillery sector, resulting in ₹300Cr+ in investment commitments.',
    accent: '#F0C808',
    highlights: ['₹300Cr+ commitments', '15 investors', '8 new projects'],
  },
];

export const mediaGallery = [
  {
    id: 1,
    type: 'photo',
    title: 'Bihar Ethanol Conclave 2025 — Opening Ceremony',
    event: 'Bihar Ethanol Conclave 2025',
    image: '/images/gallery1.jpg',
  },
  {
    id: 2,
    type: 'photo',
    title: 'MoU Signing with IOCL',
    event: 'Bihar Ethanol Conclave 2025',
    image: '/images/gallery2.jpg',
  },
  {
    id: 3,
    type: 'photo',
    title: 'Distillery Site Visit — West Champaran',
    event: 'Field Visit 2025',
    image: '/images/gallery3.jpg',
  },
  {
    id: 4,
    type: 'photo',
    title: 'Farmer Outreach Program — Muzaffarpur',
    event: 'Farmer-Distillery Summit 2025',
    image: '/images/gallery4.jpg',
  },
  {
    id: 5,
    type: 'photo',
    title: 'National Biofuel Day — Patna',
    event: 'National Biofuel Day 2025',
    image: '/images/gallery5.jpg',
  },
  {
    id: 6,
    type: 'photo',
    title: 'BEA Leadership Meeting',
    event: 'Quarterly Meeting 2026',
    image: '/images/gallery6.jpg',
  },
];

export const mediaCoverage = [
  {
    outlet: 'Mongabay India',
    headline: 'Policy Shifts Test Bihar’s Ethanol-led Industrial Revival',
    date: 'February 2026',
    type: 'Digital',
    url: 'https://india.mongabay.com/2026/02/policy-shifts-test-bihars-ethanol-led-industrial-revival/',
    summary: 'This article provides the most comprehensive "reality check" for 2026. It confirms that Bihar successfully established 19 ethanol plants with a capacity of 3,100 KLPD, but highlights that Oil Marketing Companies (OMCs) reduced procurement quotas by 50% for 2025-26, threatening shutdowns.'
  },
  {
    outlet: 'ChiniMandi',
    headline: 'Bihar: Ethanol plants are on the verge of shutdown',
    date: 'January 2026',
    type: 'Digital',
    url: 'https://www.chinimandi.com/bihar-ethanol-plants-are-on-the-verge-of-shutdown/',
    summary: 'Reports on the Bihar Ethanol Association\'s (BEA) urgent meeting with the Union Petroleum Secretary in early 2026. The delegation, led by Secretary General Kunal Kishore, lobbied against the shortfall in ethanol allocation despite the state\'s massive investment.'
  },
  {
    outlet: 'Sugaronline',
    headline: 'Bihar Govt Seeks Higher Ethanol Procurement Quota',
    date: 'February 2026',
    type: 'Digital',
    url: 'https://www.sugaronline.com/2026/02/17/india-bihar-government-seeks-higher-ethanol-procurement-quota/',
    summary: 'Details the Bihar state government\'s official intervention to protect its industrial investments. Minister Dilip Jaiswal confirmed that the state is pushing the Centre to treat grain-based ethanol on par with sugar-based ethanol to prevent plant closures.'
  },
  {
    outlet: 'ChiniMandi',
    headline: 'UP, Bihar Farmers Gain ₹42,000 Crore as Maize-to-Ethanol Lifts Prices',
    date: 'April 2026',
    type: 'Digital',
    url: 'https://www.chinimandi.com/india-should-aim-for-100-ethanol-blending-amid-energy-risks-nitin-gadkari/',
    summary: 'A statement by Union Minister Nitin Gadkari highlighting the positive economic impact on farmers due to the maize-to-ethanol surge. It notes that maize prices for Bihar farmers reached record highs because 50% of the state\'s maize is now consumed by ethanol plants.'
  },
  {
    outlet: 'Bihar Industries Dept',
    headline: 'Bihar Biofuels Production Promotion Policy 2025 Update',
    date: 'June 2025',
    type: 'Policy',
    url: 'https://betastate.bihar.gov.in/industries/DyPageView?PageTitleID=1097',
    summary: 'This is the official policy document that extended the 2021 incentives until March 2028. It introduced higher interest subvention (up to 12% for small units) and set a June 2025 deadline for financial clearance for new greenfield projects.'
  }
];

export const members = [
  {
    id: 1,
    name: 'Harinagar Sugar Mills Ltd.',
    location: 'West Champaran',
    district: 'West Champaran',
    capacity: '60 KLPD',
    type: 'Sugarcane-Based',
    established: '1992',
    status: 'Operational',
    products: ['Ethanol', 'ENA', 'RS'],
    website: 'https://harinagarsugarmills.com',
    phone: '+91 6252 234567',
    email: 'info@harinagarsugarmills.com',
    address: 'Harinagar, West Champaran, Bihar 845438',
    lat: 27.0,
    lng: 84.4,
  },
  {
    id: 2,
    name: 'Bihar Distilleries Pvt. Ltd.',
    location: 'Muzaffarpur',
    district: 'Muzaffarpur',
    capacity: '45 KLPD',
    type: 'Grain-Based',
    established: '2005',
    status: 'Operational',
    products: ['Fuel Ethanol', 'Rectified Spirit'],
    website: '#',
    phone: '+91 621 2345678',
    email: 'contact@bihardistilleries.com',
    address: 'Industrial Area, Muzaffarpur, Bihar 842001',
    lat: 26.12,
    lng: 85.36,
  },
  {
    id: 3,
    name: 'Gopalganj Agro Spirits',
    location: 'Gopalganj',
    district: 'Gopalganj',
    capacity: '100 KLPD',
    type: 'Grain-Based',
    established: '2018',
    status: 'Operational',
    products: ['Fuel Ethanol', 'Potable Alcohol'],
    website: '#',
    phone: '+91 6150 234567',
    email: 'info@gopalganjagro.com',
    address: 'SIDCUL Industrial Area, Gopalganj, Bihar 841428',
    lat: 26.47,
    lng: 84.43,
  },
  {
    id: 4,
    name: 'Saran Ethanol Industries',
    location: 'Chapra',
    district: 'Saran',
    capacity: '30 KLPD',
    type: 'Sugarcane-Based',
    established: '2001',
    status: 'Operational',
    products: ['Ethanol', 'ENA'],
    website: '#',
    phone: '+91 6152 234567',
    email: 'info@saranethanol.com',
    address: 'Chapra Industrial Estate, Saran, Bihar 841301',
    lat: 25.78,
    lng: 84.74,
  },
  {
    id: 5,
    name: 'Kosi Valley Agro Fuels',
    location: 'Supaul',
    district: 'Supaul',
    capacity: '75 KLPD',
    type: 'Grain-Based',
    established: '2020',
    status: 'Operational',
    products: ['Fuel Ethanol'],
    website: '#',
    phone: '+91 6473 234567',
    email: 'info@kosivalley.com',
    address: 'Supaul Industrial Zone, Bihar 852131',
    lat: 26.12,
    lng: 86.6,
  },
  {
    id: 6,
    name: 'Mithila Green Energy',
    location: 'Darbhanga',
    district: 'Darbhanga',
    capacity: '80 KLPD',
    type: 'Multi-Feedstock',
    established: '2019',
    status: 'Operational',
    products: ['Fuel Ethanol', 'CO2'],
    website: '#',
    phone: '+91 6272 234567',
    email: 'info@mithilagreen.com',
    address: 'Darbhanga Industrial Area, Bihar 846004',
    lat: 26.15,
    lng: 85.9,
  },
  {
    id: 7,
    name: 'Champaran Biofuels Ltd.',
    location: 'East Champaran',
    district: 'East Champaran',
    capacity: '55 KLPD',
    type: 'Sugarcane-Based',
    established: '2010',
    status: 'Operational',
    products: ['Ethanol', 'Molasses'],
    website: '#',
    phone: '+91 6252 345678',
    email: 'info@champaranbiofuels.com',
    address: 'Motihari Industrial Estate, East Champaran, Bihar 845401',
    lat: 26.65,
    lng: 84.91,
  },
  {
    id: 8,
    name: 'Vaishali Agro Distillers',
    location: 'Hajipur',
    district: 'Vaishali',
    capacity: '40 KLPD',
    type: 'Grain-Based',
    established: '2016',
    status: 'Operational',
    products: ['Fuel Ethanol', 'DDGS'],
    website: '#',
    phone: '+91 6224 234567',
    email: 'info@vaishaliagro.com',
    address: 'Hajipur Industrial Area, Vaishali, Bihar 844101',
    lat: 25.69,
    lng: 85.21,
  },
  {
    id: 9,
    name: 'Patna Ethanol Corporation',
    location: 'Patna',
    district: 'Patna',
    capacity: '120 KLPD',
    type: 'Grain-Based',
    established: '2021',
    status: 'Operational',
    products: ['Fuel Ethanol', 'CO2', 'DDGS'],
    website: '#',
    phone: '+91 612 3456789',
    email: 'info@patnaethanol.com',
    address: 'Patna Industrial Estate, Bihar 800001',
    lat: 25.6,
    lng: 85.13,
  },
];

export const stats = [
  { value: '22', label: 'Licensed Manufacturers', icon: 'ri-building-2-line' },
  { value: '35,000+', label: 'Crore Investment Facilitated', icon: 'ri-money-rupee-circle-line' },
  { value: '47+', label: 'Government MoUs Signed', icon: 'ri-file-text-line' },
  { value: '3', label: 'Major OMC Partners', icon: 'ri-gas-station-line' },
];

export const ecosystemCards = [
  {
    id: 1,
    title: 'Sugarcane & Grain Producers',
    description: 'Bihar\'s vast agricultural base with 3.0 lakh hectares under sugarcane, providing abundant feedstock for ethanol production.',
    icon: 'ri-plant-line',
    stat: '3.0L Ha',
    statLabel: 'Under Cultivation',
    color: 'bgreen',
  },
  {
    id: 2,
    title: 'Ethanol Distilleries',
    description: 'State-of-the-art distilleries producing fuel-grade ethanol across grain-based and sugarcane-based facilities.',
    icon: 'ri-flask-line',
    stat: '22',
    statLabel: 'Active Distilleries',
    color: 'navy',
  },
  {
    id: 3,
    title: 'Oil Marketing Companies',
    description: 'IOCL, BPCL and HPCL procure ethanol directly from Bihar manufacturers under the national blending mandate.',
    icon: 'ri-gas-station-line',
    stat: '3',
    statLabel: 'Major OMC Partners',
    color: 'amber',
  },
  {
    id: 4,
    title: 'Policy & Regulation',
    description: 'National Biofuel Policy 2018 and State Ethanol Policy framework enabling industry growth with fiscal incentives.',
    icon: 'ri-government-line',
    stat: 'E20',
    statLabel: 'Blending Target',
    color: 'bgreen',
  },
];

export const manufacturers = [
  {
    id: 1,
    name: 'Harinagar Sugar Mills Ltd.',
    location: 'West Champaran',
    district: 'West Champaran',
    capacity: '60 KLPD',
    type: 'Sugarcane-Based',
    established: '1992',
    status: 'Operational',
    products: ['Ethanol', 'ENA', 'RS'],
  },
  {
    id: 2,
    name: 'Bihar Distilleries Pvt. Ltd.',
    location: 'Muzaffarpur',
    district: 'Muzaffarpur',
    capacity: '45 KLPD',
    type: 'Grain-Based',
    established: '2005',
    status: 'Operational',
    products: ['Fuel Ethanol', 'Rectified Spirit'],
  },
  {
    id: 3,
    name: 'Gopalganj Agro Spirits',
    location: 'Gopalganj',
    district: 'Gopalganj',
    capacity: '100 KLPD',
    type: 'Grain-Based',
    established: '2018',
    status: 'Operational',
    products: ['Fuel Ethanol', 'Potable Alcohol'],
  },
  {
    id: 4,
    name: 'Saran Ethanol Industries',
    location: 'Chapra',
    district: 'Saran',
    capacity: '30 KLPD',
    type: 'Sugarcane-Based',
    established: '2001',
    status: 'Operational',
    products: ['Ethanol', 'ENA'],
  },
  {
    id: 5,
    name: 'Kosi Valley Agro Fuels',
    location: 'Supaul',
    district: 'Supaul',
    capacity: '75 KLPD',
    type: 'Grain-Based',
    established: '2020',
    status: 'Operational',
    products: ['Fuel Ethanol'],
  },
  {
    id: 6,
    name: 'Mithila Green Energy',
    location: 'Darbhanga',
    district: 'Darbhanga',
    capacity: '80 KLPD',
    type: 'Multi-Feedstock',
    established: '2019',
    status: 'Operational',
    products: ['Fuel Ethanol', 'CO2'],
  },
  {
    id: 7,
    name: 'Champaran Biofuels Ltd.',
    location: 'East Champaran',
    district: 'East Champaran',
    capacity: '55 KLPD',
    type: 'Sugarcane-Based',
    established: '2010',
    status: 'Operational',
    products: ['Ethanol', 'Molasses'],
  },
  {
    id: 8,
    name: 'Vaishali Agro Distillers',
    location: 'Hajipur',
    district: 'Vaishali',
    capacity: '40 KLPD',
    type: 'Grain-Based',
    established: '2016',
    status: 'Operational',
    products: ['Fuel Ethanol', 'DDGS'],
  },
  {
    id: 9,
    name: 'Patna Ethanol Corporation',
    location: 'Patna',
    district: 'Patna',
    capacity: '120 KLPD',
    type: 'Grain-Based',
    established: '2021',
    status: 'Operational',
    products: ['Fuel Ethanol', 'CO2', 'DDGS'],
  },
];

export const govPartners = [
  {
    id: 1,
    category: 'State Government',
    name: 'Department of Industries, Government of Bihar',
    role: 'Nodal department for industrial policy, licensing, and ethanol promotion in Bihar. Facilitates single-window clearance for new distilleries.',
    icon: 'ri-government-line',
    color: '#0D1F3C',
  },
  {
    id: 2,
    category: 'State Government',
    name: 'Bihar Renewable Energy Development Agency (BREDA)',
    role: 'Promotes renewable energy including biofuels. Provides technical assistance and policy support to manufacturers.',
    icon: 'ri-flashlight-line',
    color: '#1A5C38',
  },
  {
    id: 3,
    category: 'Central Government',
    name: 'Ministry of Petroleum & Natural Gas (MoPNG)',
    role: 'Sets national ethanol blending targets, procurement prices, and policy framework under the Ethanol Blended Petrol (EBP) Programme.',
    icon: 'ri-government-fill',
    color: '#0D1F3C',
  },
  {
    id: 4,
    category: 'Central Government',
    name: 'Ministry of Food Processing Industries (MoFPI)',
    role: 'Provides financial assistance for grain-based distilleries under PLI and other schemes. Promotes value-chain development.',
    icon: 'ri-seedling-line',
    color: '#1A5C38',
  },
  {
    id: 5,
    category: 'Oil Marketing Company',
    name: 'Indian Oil Corporation Ltd. (IOCL)',
    role: 'Largest OMC procuring ethanol from Bihar distilleries. Manages blending logistics and issues annual tenders for EBP procurement.',
    icon: 'ri-gas-station-fill',
    color: '#B45309',
  },
  {
    id: 6,
    category: 'Oil Marketing Company',
    name: 'Bharat Petroleum Corporation Ltd. (BPCL)',
    role: 'Procures fuel-grade ethanol from Bihar manufacturers. Operates blending depots across the state.',
    icon: 'ri-gas-station-line',
    color: '#B45309',
  },
  {
    id: 7,
    category: 'Oil Marketing Company',
    name: 'Hindustan Petroleum Corporation Ltd. (HPCL)',
    role: 'Part of the national EBP programme. Manages ethanol procurement logistics in the eastern region.',
    icon: 'ri-oil-line',
    color: '#B45309',
  },
  {
    id: 8,
    category: 'Financial Institution',
    name: 'State Bank of India (SBI)',
    role: 'Lead banker for most ethanol projects in Bihar. Offers concessional finance under government-backed lending schemes.',
    icon: 'ri-bank-line',
    color: '#1e40af',
  },
];

export const timelineEvents = [
  {
    year: '2005',
    title: 'BEA Founded',
    description: 'Bihar Ethanol Association established by pioneer distillers to advocate for the ethanol sector in Bihar.',
  },
  {
    year: '2009',
    title: 'First OMC MoU',
    description: 'Landmark agreement with IOCL for long-term ethanol procurement from member distilleries.',
  },
  {
    year: '2014',
    title: 'State Policy Advocacy',
    description: 'BEA\'s advocacy contributed to Bihar\'s first dedicated ethanol industry incentive package.',
  },
  {
    year: '2018',
    title: 'National Biofuel Policy',
    description: 'BEA members positioned to benefit from the National Biofuel Policy 2018 and E10 blending mandate.',
  },
  {
    year: '2021',
    title: 'Grain-Based Expansion',
    description: 'BEA facilitated 12 new grain-based distillery approvals in Bihar, adding 400 KLPD capacity.',
  },
  {
    year: '2026',
    title: 'E20 Mission Drive',
    description: 'BEA actively supporting Bihar members in scaling capacity ahead of India\'s E20 target for 2025.',
  },
];

export const leadershipTeam = [
  {
    name: 'Rajiv Kumar Sinha',
    designation: 'President',
    company: 'Patna Ethanol Corporation',
    image: '/images/lead1.jpg',
  },
  {
    name: 'Priya Shankar Mishra',
    designation: 'Secretary General',
    company: 'Bihar Distilleries Pvt. Ltd.',
    image: '/images/lead2.jpg',
  },
  {
    name: 'Sunita Devi',
    designation: 'Treasurer',
    company: 'Mithila Green Energy',
    image: '/images/lead3.jpg',
  },
  {
    name: 'Amit Verma',
    designation: 'Vice President',
    company: 'Gopalganj Agro Spirits',
    image: '/images/lead4.jpg',
  },
];
